
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiCameraOff as ObiCameraOffElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-camera-off.js';
 
 
 

 
 export const ObiCameraOff = createComponent({
   react: React,
   tagName: 'obi-camera-off',
   elementClass: ObiCameraOffElement,
   events: {
     
   }
  });
 
 